import { useContext } from 'react';
import { OtpModalVM } from './types';
import { OtpModalContext } from './context';

/**
 * Hook per accedere al contesto dell'OTP modal.
 * @returns {OtpModalVM} - oggetto contenente le seguenti proprietà:
 *   data: { open: boolean } - indica lo stato dell'OTP modal
 *   toggleModal: (open: boolean) => void - metodo per controllare lo stato dell'OTP modal
 */
export default function useOtpModal(): OtpModalVM {
  return useContext(OtpModalContext);
}
